class Swipe {
	constructor(element, options) {
		const self = this;


		this.state = {
			initialX: null,
			initialY: null,
			currentX: null,
			currentY: null,
			isHorizontalSwipping: false
		};

		this.options = {
			onSwipeStart: options.onSwipeStart || function () {},
			onSwipping: options.onSwipping || function () {},
			onSwipeEnd: options.onSwipeEnd || function () {},
			onSwipeLeft: options.onSwipeLeft || function () {},
			onSwipeRight: options.onSwipeRight || function () {},
			onSwipeUp: options.onSwipeUp || function () {},
			onSwipeDown: options.onSwipeDown || function () {},
		};

		self._element = element;
	}

	swipeStart(event) {
		this.options.onSwipeStart();

		// set initial position
		this.state.initialX = event.touches[0].clientX;
		this.state.initialY = event.touches[0].clientY;

	}

	swipping(event) {
		this.options.onSwipping();

		if (this.state.isHorizontalSwipping) {
			event.preventDefault();
		}

		/*
		* This prevent all the code of this function to execute all the time while touching the screen.
		* The first touch will set the initial positions in swipeStart()
		* Then, in the end of this function, that will be set to null, causing this
		* to exit the function and preventing all the code get executed again and again
		*/
		if (this.state.initialX === null) return;
		if (this.state.initialY === null) return;

		const currentX = event.touches[0].clientX;
		const currentY = event.touches[0].clientY;

		const diffX = this.state.initialX - currentX;
		const diffY = this.state.initialY - currentY;

		if (Math.abs(diffX) > Math.abs(diffY)) {
			// sliding horizontally
			event.preventDefault();
			this.state.isHorizontalSwipping = true;
			if (diffX > 0) {
				// swipe left
				this.options.onSwipeLeft();
			} else {
				// swipe right
				this.options.onSwipeRight();
			}
		} else {
			if (diffY > 0) {
				// swipe up
				this.options.onSwipeUp();
			} else {
				// swipe down
				this.options.onSwipeDown();
			}
		}

		this.state.initialX = null;
		this.state.initialY = null;
	}

	swipeEnd() {
		this.options.onSwipeEnd();
		this.state.isHorizontalSwipping = false;
	}
}

export default Swipe;
